import service from './service'

const getAllServiceOccurrences = async ({ commit }) => {
  const data = await (await service.getAllServiceOccurrences()).data

  await commit('SAVE_ALL_SERVICE_OCCURRENCES', data)
}

export default {
  getAllServiceOccurrences,
}
